import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { basketAnalysis: { getBasketAnalysis, } } = apiUrls;

export const BASKET_ANALYSIS_SUCCESS = 'BASKET_ANALYSIS_SUCCESS';
export const BASKET_ANALYSIS_LOADING = 'BASKET_ANALYSIS_LOADING';


export const getBasketAnalysisData = ({ fromDate, toDate, salesChannel
    , productCategorizationBasedOn, vendor }) => async (dispatch) => {
        try {
        if (vendor) {
            const { url } = getBasketAnalysis
            const requestData = {
                ...getBasketAnalysis, url: getBasketAnalysis.url.replace('{{vendor}}', vendor),
                data: {
                    fromDate,
                    toDate,
                    productCategorizationBasedOn,
                    salesChannel
                }                
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: BASKET_ANALYSIS_SUCCESS,
                data,
                vendor
            })
        }
        } catch (e) {

            dispatch({
                type: BASKET_ANALYSIS_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
                vendor
            })
        }

    }


export const handleLoader = (isLoading, vendor ) => (dispatch) => {
    if (vendor) {
    dispatch({
        type: BASKET_ANALYSIS_LOADING,
        isLoading,
        vendor
    })
}
}
